import {Component, Input, OnInit} from '@angular/core';
import {FinalConceptsData} from '../models/finalConceptsData';
import {ParticipantOverview} from 'src/app/calibration/_interfaces/participant-overview.interface';
import {BaseClass} from 'src/app/shared/classes/base';
import {ToastController} from '@ionic/angular';
import {TranslationService} from 'src/app/shared/services/translation.service';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-general-valuation-final-concepts-table',
    templateUrl: './general-valuation-final-concepts-table.component.html',
    styleUrls: ['./general-valuation-final-concepts-table.component.scss'],
})
export class GeneralValuationFinalConceptsTableComponent extends BaseClass implements OnInit {
    public anyCalculated: boolean = false;
    public goalsCalculated: boolean = false;
    public useTranslationOnOverallEvaluation: boolean;
    public principleCalculated: boolean = false;
    public finalCalculated: boolean = false;

    public _user: Partial<ParticipantOverview>;
    @Input() set user(value: Partial<ParticipantOverview>) {
        this._user = value;
        this.getSummaryInformation();
    }

    @Input() isManagement: boolean = false;


    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit(): void {
        this.useTranslationOnOverallEvaluation = this._configService.settings.features.useTranslationOnOverallEvaluation;
    }

    private getSummaryInformation() {
        this.selectedLanguage = this._translationService.getSelectedLanguage();
        this.anyCalculated =
            this._user
            && (
                this._user.selfEvaluation
                && (this._user.selfEvaluation.finalGoalsSelfEvaluationRelatedQuestionsUsed
                    || this._user.selfEvaluation.finalPrinciplesSelfEvaluationRelatedQuestionsUsed
                    || this._user.selfEvaluation.finalSelfEvaluationRelatedQuestionsUsed)
                || this._user.managerEvaluation
                && (this._user.managerEvaluation.finalGoalsManagerEvaluationRelatedQuestionsUsed
                    || this._user.managerEvaluation.finalPrinciplesManagerEvaluationRelatedQuestionsUsed
                    || this._user.managerEvaluation.finalManagerEvaluationRelatedQuestionsUsed)
            );
        this.goalsCalculated = (this._user && this._user.selfEvaluation && this._user.selfEvaluation.finalGoalsSelfEvaluationRelatedQuestionsUsed)
            || (this._user && this._user.managerEvaluation && this._user.managerEvaluation.finalGoalsManagerEvaluationRelatedQuestionsUsed)
            || false;
        this.principleCalculated = (this._user && this._user.selfEvaluation && this._user.selfEvaluation.finalPrinciplesSelfEvaluationRelatedQuestionsUsed)
            || (this._user && this._user.managerEvaluation && this._user.managerEvaluation.finalPrinciplesManagerEvaluationRelatedQuestionsUsed)
            || false;
        this.finalCalculated = (this._user && this._user.selfEvaluation && this._user.selfEvaluation.finalSelfEvaluationRelatedQuestionsUsed)
            || (this._user && this._user.managerEvaluation && this._user.managerEvaluation.finalManagerEvaluationRelatedQuestionsUsed)
            || false;
    }
}
